import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import ChatWidget from "./ChatWidget";
import CookieBanner from "./CookieBanner";
import { Seo } from "./Seo";

export default function Layout({ children, noFooter }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#F4EAD9]">
      <Seo />
      <Header />
      <main className="flex-1">{children}</main>
      {!noFooter && <Footer />}
      <ChatWidget />
      <CookieBanner />
    </div>
  );
}
